import { Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import type { ReactNode } from "react";

type RulebookProfileSectionHeadingProps = {
  title: ReactNode;
  subtitle?: ReactNode;
  action?: ReactNode;
};

const RulebookProfileSectionHeading = ({ title, subtitle, action }: RulebookProfileSectionHeadingProps) => (
  <div className="flex items-end gap-3" data-testid="RulebookProfileSectionHeading">
    <div className="flex min-w-0 flex-1 flex-col gap-0.5">
      <Text variant={TextVariants.HEADING_6_MEDIUM} className="text-[18px] font-semibold leading-6">
        {title}
      </Text>
      {subtitle ? (
        <Text variant={TextVariants.LABEL_SMALL_REGULAR} className="text-[13px] text-gray-11">
          {subtitle}
        </Text>
      ) : null}
    </div>
    {action ? <div className="shrink-0">{action}</div> : null}
  </div>
);

export default RulebookProfileSectionHeading;
